<template>
  <section class="help-banner">
    <div class="help-banner-inner">
      <div class="help-content">
        <div class="help-icon">
          <i class="el-icon-chat-dot-square"></i>
        </div>
        <div class="help-text">
          <div class="help-title">Need assistance?</div>
          <div class="help-desc"><span class="help-highlight">Tell us</span> what you're looking for and our managers
            will help you!</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HelpBanner'
}
</script>

<style scoped>
.help-banner {
  width: 100%;
  padding: 0 20px 32px;
  background-color: #fff;
}

.help-banner-inner {
  max-width: 1100px;
  height: 98px;
  margin: 0 auto;
  padding: 0 28px;
  display: flex;
  align-items: center;
  background-color: #fff1ed;
  border-radius: 3px;
}

.help-content {
  display: flex;
  align-items: center;
  gap: 28px;
}

.help-icon {
  width: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff5a1f;
}

.help-icon i {
  font-size: 48px;
}

.help-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.help-title {
  color: #333;
  font-size: 18px;
  font-weight: 700;
}

.help-desc {
  color: #555;
  font-size: 13px;
}

.help-highlight {
  margin-right: 4px;
  color: #ff5a1f;
}

@media (max-width: 640px) {
  .help-banner-inner {
    height: auto;
    padding: 22px;
  }

  .help-content {
    gap: 18px;
  }

  .help-icon {
    width: 44px;
  }

  .help-icon i {
    font-size: 36px;
  }
}
</style>
